import { IGetPatientAdherenceDataResponse } from "../../../../@types/Treatments";

export const adherenceConfig = [
  {
    type: "FullAdherence",
    labelKey: "dashboard_adherence_full",
    fill: "#A7DEC2",
    getValue: (data: IGetPatientAdherenceDataResponse) =>
      data.fullAdherenceCount,
  },
  {
    type: "PartialAdherence",
    labelKey: "dashboard_adherence_partial",
    fill: "#F8C9A0",
    getValue: (data: IGetPatientAdherenceDataResponse) =>
      data.partialAdherenceCount,
  },
  {
    type: "NoAdherence",
    labelKey: "dashboard_adherence_none",
    fill: "#F1B6C2",
    getValue: (data: IGetPatientAdherenceDataResponse) => data.noAdherenceCount,
  },
  {
    type: "NotSynced",
    labelKey: "dashboard_adherence_notSynced",
    fill: "#CECECE",
    getValue: (data: IGetPatientAdherenceDataResponse) => data.notSyncedCount,
  },
  {
    type: "OverAdherence",
    labelKey: "dashboard_adherence_overuse",
    fill: "#B8AFE6",
    getValue: (data: IGetPatientAdherenceDataResponse) =>
      data.overAdherenceCount,
  },
];

export const opacityConfig = {
  default: 1,
  selected: 1,
  hovered: 0.68,
  dimmed: 0.22,
};

export const calculateYAxisDomain = (
  data: IGetPatientAdherenceDataResponse
) => {
  const total = adherenceConfig
    .map((cfg) => cfg.getValue(data))
    .reduce((sum, value) => sum + value, 0);

  const max = Math.ceil(total / 10) * 10;

  return [0, max];
};
